import { createBrowserHistory, createMemoryHistory } from 'history'
import localHistory from '../modules/localHistory'

const appHistory =
  process.env.NODE_ENV === 'test'
    ? createMemoryHistory()
    : createBrowserHistory()

localHistory.init(appHistory)

export default appHistory



// WEBPACK FOOTER //
// ./src/core/history.js